import { render, staticRenderFns } from "./DynamicDetailsLayer.vue?vue&type=template&id=f24b2ab0&scoped=true&"
import script from "./DynamicDetailsLayer.vue?vue&type=script&lang=js&"
export * from "./DynamicDetailsLayer.vue?vue&type=script&lang=js&"
import style0 from "./DynamicDetailsLayer.vue?vue&type=style&index=0&id=f24b2ab0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24b2ab0",
  null
  
)

export default component.exports